import { reset } from './show-mockups.actions';
export const showMockupsDispatcher = dispatch => ({
  reset: () => {
    dispatch(reset());
  }
});